import React from 'react';
import styled from 'styled-components';

import { LineItemContainer } from 'pages/Totem/Aside/Basket/LineItemContainer';

interface BasketButtonLineItemProps {
    actionLabel: React.ReactNode;
    borderBottom?: boolean;
    bold?: boolean;
    dataTest?: string;
    disabled?: boolean;
    icon?: React.ReactNode;
    label?: React.ReactNode;
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

export const BasketButtonLineItem: React.FC<BasketButtonLineItemProps> = ({
    actionLabel,
    borderBottom,
    bold = true,
    dataTest,
    disabled = false,
    icon,
    label,
    onClick,
}) => {
    return (
        <LineItemContainer
            as="button"
            onClick={onClick}
            $borderBottom={borderBottom}
            disabled={disabled}
            data-test={dataTest}
        >
            <LabelAndIcon>
                {icon}
                {label}
            </LabelAndIcon>
            {!disabled && <ActionLabel $bold={bold}>{actionLabel}</ActionLabel>}
        </LineItemContainer>
    );
};

const LabelAndIcon = styled.div`
    svg {
        margin-right: 1.6rem;
    }
    display: flex;
    align-items: center;
`;

interface ActionLabelProps {
    $bold?: boolean;
}

const ActionLabel = styled.div<ActionLabelProps>`
    font-weight: ${({ $bold }) => ($bold ? 800 : 500)};
    cursor: pointer;
`;
